import { CartAddEvent, CartErrorEvent } from '@theme/events';
import { fetchConfig } from '@theme/utilities';

const selectors = {
  addButton: '[data-cart-upsell-add]',
  cartItemsComponent: 'cart-items-component',
};

if (!window.__enhancedCartUpsellsInitialized) {
  window.__enhancedCartUpsellsInitialized = true;

  document.addEventListener('click', async (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const button = target.closest(selectors.addButton);
    if (!(button instanceof HTMLButtonElement)) return;

    event.preventDefault();

    const variantId = button.dataset.variantId;
    if (!variantId || button.disabled) return;

    const originalText = button.textContent || '';
    const propertyName = button.dataset.propertyName || '';
    const propertyValue = button.dataset.propertyValue || '';
    const sectionIds = getCartSectionIds();

    button.disabled = true;
    button.dataset.loading = 'true';

    try {
      /** @type {{ items: Array<{ id: number; quantity: number; properties?: Record<string, string> }>; sections?: string; sections_url?: string }} */
      const body = {
        items: [
          {
            id: Number(variantId),
            quantity: 1,
          },
        ],
      };

      if (propertyName) {
        body.items[0].properties = { [propertyName]: propertyValue };
      }

      if (sectionIds.length > 0) {
        body.sections = sectionIds.join(',');
        body.sections_url = window.location.pathname;
      }

      const response = await fetch(Theme.routes.cart_add_url, {
        ...fetchConfig('json', {
          body: JSON.stringify(body),
        }),
      });

      const cartResponse = await response.json();

      if (!response.ok || cartResponse.status) {
        throw cartResponse;
      }

      button.dispatchEvent(
        new CartAddEvent(cartResponse, variantId, {
          source: 'cart-upsells',
          itemCount: 1,
          variantId,
          sections: cartResponse.sections,
        })
      );
    } catch (error) {
      console.error(error);

      const message =
        error && typeof error === 'object' && 'message' in error
          ? String(error.message)
          : Theme.translations?.add_to_cart_error || 'Error adding to cart';

      button.dispatchEvent(new CartErrorEvent('cart-upsells', message, message, error));
      button.disabled = false;
      button.textContent = originalText;
    } finally {
      button.removeAttribute('data-loading');
    }
  });
}

function getCartSectionIds() {
  const sectionIds = new Set();
  const drawerCartItemsComponent = document.querySelector('cart-drawer-component cart-items-component');

  if (drawerCartItemsComponent instanceof HTMLElement && drawerCartItemsComponent.dataset.sectionId) {
    sectionIds.add(drawerCartItemsComponent.dataset.sectionId);
  } else {
    document.querySelectorAll(selectors.cartItemsComponent).forEach((component) => {
      if (component instanceof HTMLElement && component.dataset.sectionId) {
        sectionIds.add(component.dataset.sectionId);
      }
    });
  }

  return Array.from(sectionIds);
}
